var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityLeft = function SvgSecurityLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentcolor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.848 4.224a1.33 1.33 0 0 0-1.244-.126 1.32 1.32 0 0 0-.82 1.22 1.326 1.326 0 1 0 2.064-1.094M1.043 7.072c.206-.086.428-.13.652-.13h2.796A1.726 1.726 0 0 1 6.197 8.68v4.039a.573.573 0 0 1-1.147 0V9.006h-.269v10.176a.773.773 0 1 1-1.546 0V13.28h-.263v5.903a.773.773 0 1 1-1.54 0V9.006h-.276v3.714a.58.58 0 1 1-1.153 0V8.653a1.69 1.69 0 0 1 1.04-1.581"
  })));
};
export default SvgSecurityLeft;